// extracted by mini-css-extract-plugin
export default {"container":"WordGameLayout_container__nIzda","sub_container":"WordGameLayout_sub_container__eaa2R"};